import { SiteControlWidget } from '@scaleaq/sitecontrol-lib';
import { v4 as uuidv4 } from 'uuid';

import {
  defaultGridItemPosition,
  defaultGridItemSize,
} from '@/pages/landingPage/constants/defaultGridItemSizeAndPosition.ts';

export type GetNewWidgetProps = {
  componentName: string;
  defaultWidgetConfig: object;
  layoutId: string;
  siteId: string;
};

/**
 * Creates a new widget record (id, props, default size/position).
 * Default `x`/`y` are placeholders only — use {@link getNewWidgetForLayoutAppend} when adding to a grid.
 */
export const getNewWidget = ({
  componentName,
  defaultWidgetConfig,
  layoutId,
  siteId,
}: GetNewWidgetProps): SiteControlWidget => {
  const newWidget: SiteControlWidget = {
    id: uuidv4(),
    props: defaultWidgetConfig,
    componentName,
    ...defaultGridItemSize,
    ...defaultGridItemPosition,
    layoutId,
    siteId,
  };
  return newWidget;
};
